import styled from 'styled-components';
import { Card, Heading3, Heading4, P } from '@ovotech/element-v4';
import { mqMediumDown, mqMediumUp } from '@/src/utils/mediaQuery';

export const SectionHeading = styled(Heading3)`
  ${({ theme }) => `
    span {
      color: ${theme.colors.brand.midnight};
    }
  `}
`;

export const BeyondCard = styled(Card)`
  ${({ theme }) => `
    border-radius: 22px;
    padding: ${theme.space[4]};
    position: relative;

    ${mqMediumUp(`
        padding: ${theme.space[6]};
    `)}
  `}
`;

export const CardTitle = styled(Heading4)`
  ${({ theme }) => `
    color: ${theme.colors.brand.midnight};
  `}

  ${mqMediumDown(`
        max-width: 80%;
    `)}
`;

export const GridContainer = styled.div`
  ${({ theme }) => `
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${theme.space[3]};

    ${mqMediumUp(`
        grid-template-columns: repeat(3, 1fr);
        gap: ${theme.space[8]};
    `)}
  `}
`;

export const CardText = styled(P)`
  ${mqMediumDown(`
        display: none;
    `)}
`;

export const IconWrapper = styled.div`
  ${({ theme }) => `
    width: 72px;
    height: 72px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    overflow: hidden;

    margin-bottom: ${theme.space[3]};

    svg {
      height: 80%;
      width: auto;
    }

    ${mqMediumUp(`
        width: 120px;
        height: 120px;
    `)}
  `}
`;

export const AnalyticsPotentialClickButton = styled.button`
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  position: absolute;
`;
